import { useTranslation } from 'react-i18next';
import { ProjectStatusEnum } from 'src/shared/enums/projectStatus.enum';
import { Box } from '@mui/material';
import { ControlledCheckBox } from '../form/controlledCheckBox';
import { ControlledTextInputDense } from '../form/controlledTextInputDense';

type SustainabilityCheckboxesEngineeringProps = {
  projectStatus: number;
};

export const SustainabilityCheckboxesEngineering = (
  props: SustainabilityCheckboxesEngineeringProps,
) => {
  const { projectStatus } = props;
  const { t } = useTranslation();

  const isDisabled =
    projectStatus !== ProjectStatusEnum.Created &&
    projectStatus !== ProjectStatusEnum.SupplementRequested;
  return (
    <>
      <ControlledCheckBox
        name='checkboxSafeCoworker'
        label={t('checkboxSafeCoworker')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxClimateBenefit'
        label={t('checkboxClimateBenefit')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxWasteSorting'
        label={t('checkboxWasteSortingEngineer')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxMeetingPlan'
        label={t('checkboxMeetingPlan')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxSustainabilitySolutionTech'
        label={t('checkboxSustainabilitySolutionTech')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxSustainabilityEvaluationTech'
        label={t('checkboxSustainabilityEvaluationTech')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <ControlledCheckBox
        name='checkboxProjectSize100TSEK'
        label={t('checkboxProjectSize100TSEK')}
        labelPlacement='end'
        readOnly={isDisabled}
        useErrorSummery
      />
      <Box mt={3} display='flex' flexDirection='column'>
        <ControlledTextInputDense
          name='invoicedAmount'
          formLabel={t('invoicedAmount')}
          size='small'
          readOnly={isDisabled}
          useErrorSummery
        />
      </Box>
      <Box mt={3} display='flex' flexDirection='column'>
        <ControlledTextInputDense
          name='climateBenefitDescription'
          formLabel={t('climateBenefitDescription')}
          fullwidth
          multiline
          rows={7}
          size='small'
          readOnly={isDisabled}
          useErrorSummery
        />
      </Box>
      <Box mt={3} display='flex' flexDirection='column'>
        <ControlledTextInputDense
          name='sustainabilitySolutionTechDescription'
          formLabel={t('sustainabilitySolutionTechDescription')}
          fullwidth
          multiline
          rows={7}
          size='small'
          readOnly={isDisabled}
          useErrorSummery
        />
      </Box>
    </>
  );
};
